module.exports = __webpack_public_path__ + "static/media/brain.b7c7f3e7.png";